import { createContext, useContext } from 'react'
import { CommandButton, ServiceSessionType } from './types'

interface CommandExecutionContextValue {
  requestCommand: (button: CommandButton) => void
  isBusy: (name: string) => boolean
  // Set while a Service app session holds the robot — every button reads it for its
  // disabled-reason tooltip, which is why it rides the context instead of six layout props.
  blockingSessionType: ServiceSessionType | null
}

const CommandExecutionContext = createContext<CommandExecutionContextValue | null>(null)

export const useCommandExecution = (): CommandExecutionContextValue => {
  const ctx = useContext(CommandExecutionContext)
  if (!ctx) throw new Error('useCommandExecution must be used within CommandExecutionContext.Provider')
  return ctx
}

export default CommandExecutionContext
